import { configureYupErrors } from "~/lib/i18n/yupErrors";

configureYupErrors();

export * from "yup/lib";
